import React from 'react'

import classnames from 'classnames/bind'

import Layout from 'components/shared/Layout'
import CardsGrid from 'components/shared/CardsGrid'
import MultiSelect from 'components/shared/MultiSelect'
import GradientHeaderWithIntro from 'components/shared/GradientHeaderWithIntro'
import LoadMore from 'components/shared/LoadMore'
import CirclePictureContent from 'components/shared/CardWithArrowLink/CirclePictureContent'

import { CardWithArrowLinkProps } from 'components/shared/CardWithArrowLink'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const CardsWithIntro = ({
  className,
  gradientHeader,
  intro,
  categories,
  cards,
  hasMore,
  onClick,
  bottomLink,
  onChange,
}) => {
  const customCardProps = CardWithArrowLinkProps.customCardProps

  return (
    <GradientHeaderWithIntro
      gradientHeader={gradientHeader}
      intro={{
        ...intro,
      }}
      className={cx(css.CardsWithIntro, className)}
      wrapperClassName={css.container}
    >
      {cards && (
        <Layout type="wrapper" className={cx(css.wrapper, className)}>
          <Layout type="innerWrapper" className={cx(css.wrapper, className)}>
            <CardsGrid
              cards={cards}
              bottomLink={bottomLink}
              customCardComponent={CirclePictureContent}
              customCardProps={customCardProps}
            />
          </Layout>
        </Layout>
      )}
      {hasMore && <LoadMore onClick={onClick} tagName="button" />}
    </GradientHeaderWithIntro>
  )
}

export default CardsWithIntro
